import ImageAttachment from './ImageAttachment';

export default ImageAttachment;
